module.exports = __webpack_public_path__ + "media/images/logo_small-5e86b324ca91f0bd3d49d6161ed9381b.svg";